<template>
  <section class="materials">
    <div v-if="materialsList.length>0">
      <div v-for="(list,index) in materialsList" :key="index">
        <div v-if="list.courseDocumentList.length>0" class="list">
          <h3 class="class-title">{{list.courseName}}</h3>
          <ul v-if="list.courseDocumentList.length>0">
            <li v-for="(item,itemIndex) in list.courseDocumentList" :key="itemIndex">
              <div class="list-materials" @click="clickName(item.url)">
                <i :class="{'icon':true,'pdf':item.fileType==='pdf','word':item.fileType==='word'}"></i>
                <em>{{item.name}}</em>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <NotData v-else :top="120"></NotData>
  </section>
</template>

<script>
export default {
  name: 'CourseMaterials',
  data() {
    return {
      // 资料列表
      materialsList: []
    }
  },
  created() {
    this.getMaterialsList()
  },
  methods: {
    // 获取资料列表
    getMaterialsList() {
      this.$axios.$get(`/learning/user/project/pc/documentList/v1`, {
        params: {
          projectId: this.$route.params.id
        }
      }).then(res => {
        this.materialsList = res
      }).catch(() => { })
    },
    // 点击名称查看资料
    clickName(url) {
      window.open(url, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.materials {
  padding: 30px 0 5px;
  min-height: 500px;
  .list {
    margin-bottom: 25px;
    .class-title {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: $grey-font-color;
    }
    .list-materials {
      margin-top: 10px;
      padding: 0 10px;
      height: 54px;
      display: flex;
      align-items: center;
      background: #f1f3f8;
      border-radius: 8px;
      cursor: pointer;
      .icon {
        display: inline-block;
        width: 22px;
        height: 20px;
        margin-right: 10px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &.pdf {
          background-image: url("@/assets/image/pdf.png");
        }
        &.word {
          background-image: url("@/assets/image/word.png");
        }
      }
      span {
        line-height: 24px;
        font-weight: 500;
        font-size: 16px;
        font-family: $font-family-PingFangMedium;
      }
    }
  }
}
</style>